export const TRANSITION_DURATION = 200;
export const TRANSITION_EASING = 'cubic-bezier(0.2, 0, 0.2, 1)';
